// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"d66d0e16","442":"6b9178bc","806":"31d6cfe0"}[chunkId] + ".chunk.css";
};